<template>
  <div id="partners-modal">
    <div class="input-part">
      <basic-input
        :label="$t('partnersScreen.partnersModal.inputs.name.label')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.name')"
        class="name-input row"
        v-model="name"
      />
      <basic-input
        :label="$t('partnersScreen.partnersModal.inputs.partnerID.label')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.partnerID')"
        class="partner-id-input row"
        v-model="partnerID"
      />
      <basic-input
        :label="$t('partnersScreen.partnersModal.inputs.email')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.email')"
        class="email-input row"
        v-model="email"
      />
      <basic-input
        :label="$t('partnersScreen.partnersModal.inputs.location')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.location')"
        class="location-input row"
        v-model="location"
      />
      <basic-input
        type="number"
        :label="$t('partnersScreen.partnersModal.inputs.longitude.label')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.longitude')"
        class="coordinates-input row"
        v-model="longitude"
      />
      <basic-input
        type="number"
        :label="$t('partnersScreen.partnersModal.inputs.latitude.label')"
        :placeholder="$t('partnersScreen.partnersModal.inputs.latitude')"
        class="coordinates-input row"
        v-model="latitude"
      />
      <basic-checkbox
        :text="$t('partnersScreen.partnersModal.inputs.isPassiveStore')"
        class="checkbox"
        v-model="isPassiveStore"
      />
    </div>
    <div class="save-button-part">
      <rounded-button
        :disabled="isButtonDisabled"
        @click="savePartner"
        width="100%"
      >
        {{ $t("profileScreen.profileTabs.inputs.save") }}
      </rounded-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "PartnersModal",
  props: {
    partner: {
      type: Object,
      required: false
    }
  },
  components: {},
  data: () => ({
    name: undefined,
    partnerID: undefined,
    email: undefined,
    location: undefined,
    longitude: undefined,
    latitude: undefined,
    isPassiveStore: false
  }),
  created() {
    if (this.partner) {
      this.initPartner();
    }
  },
  computed: {
    isButtonDisabled() {
      return !(
        this.computedBody &&
        this.name &&
        this.partnerID &&
        this.longitude &&
        this.latitude
      );
    },
    computedBody() {
      let data = undefined;
      if (this.name) {
        if (this.partner) {
          if (this.name !== this.partner.name) {
            if (data === undefined) {
              data = {};
            }
            data["name"] = this.name;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["name"] = this.name;
        }
      }
      if (this.partnerID) {
        if (this.partner) {
          if (this.partnerID !== this.partner.partnerID) {
            if (data === undefined) {
              data = {};
            }
            data["partnerID"] = this.partnerID;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["partnerID"] = this.partnerID;
        }
      }
      if (this.email) {
        if (this.partner) {
          if (this.email !== this.partner.email) {
            if (data === undefined) {
              data = {};
            }
            data["email"] = this.email;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["email"] = this.email;
        }
      }
      if (this.location) {
        if (this.partner) {
          if (this.location !== this.partner.location) {
            if (data === undefined) {
              data = {};
            }
            data["location"] = this.location;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["location"] = this.location;
        }
      }
      if (this.isPassiveStore !== undefined) {
        const value = this.isPassiveStore ? 1 : 0;
        if (this.partner) {
          if (value !== this.partner.isPassiveStore) {
            if (data === undefined) {
              data = {};
            }
            data["isPassiveStore"] = value;
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["isPassiveStore"] = value;
        }
      }
      if (this.longitude && this.latitude) {
        if (this.partner) {
          if (
            this.longitude !== JSON.parse(this.partner.coordinates).long ||
            this.latitude !== JSON.parse(this.partner.coordinates).lat
          ) {
            if (data === undefined) {
              data = {};
            }
            data["coordinates"] = { long: this.longitude, lat: this.latitude };
          }
        } else {
          if (data === undefined) {
            data = {};
          }
          data["coordinates"] = { long: this.longitude, lat: this.latitude };
        }
      }
      return data;
    }
  },
  methods: {
    ...mapActions({
      createPartner: "partners/createPartner",
      updatePartner: "partners/updatePartner"
    }),
    savePartner() {
      if (this.partner) {
        this.updatePartner({ id: this.partner.id, body: this.computedBody })
          .then(res => {
            if (res.status === "OK") {
              this.$notification.showNoti(
                "success",
                "partnerModal.update.success"
              );
              this.$eventBus.closeModal();
              this.$emit("refreshData");
            } else {
              this.$notification.showNoti("error", null, res);
            }
          })
          .catch(() =>
            this.$notification.showNoti("error", "partnerModal.update.error")
          );
      } else {
        this.createPartner(this.computedBody)
          .then(res => {
            if (res.status === "OK") {
              this.$notification.showNoti(
                "success",
                "partnerModal.create.success"
              );
              this.$eventBus.closeModal();
              this.$emit("refreshData");
            } else {
              this.$notification.showNoti("error", null, res);
            }
          })
          .catch(() =>
            this.$notification.showNoti("error", "partnerModal.create.error")
          );
      }
    },
    initPartner() {
      this.name = this.partner.name;
      this.partnerID = this.partner.partnerID;
      this.email = this.partner.email;
      this.location = this.partner.location;
      this.email = this.partner.email;
      this.isPassiveStore = this.partner.isPassiveStore;
      this.longitude = JSON.parse(this.partner.coordinates).long;
      this.latitude = JSON.parse(this.partner.coordinates).lat;
    }
  }
};
</script>

<style lang="scss" scoped>
#partners-modal {
  padding: 10px;
  .input-part {
    .row {
      margin-bottom: 10px;
    }
  }
  .checkbox {
    justify-content: flex-start;
    margin-left: 3px;
  }
  .save-button-part {
    margin-top: 20px;
  }
}
</style>
